import { render, staticRenderFns } from "./SegmentationClassTool.vue?vue&type=template&id=8d222a9e&"
import script from "./SegmentationClassTool.vue?vue&type=script&lang=js&"
export * from "./SegmentationClassTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports